import DailyFerryCreate from "@/controllers/daily_ferry/daily-ferry-create.js";
import axios from 'axios';
import ValidationService from '@/services/ValidationService';

export default {
  extends: DailyFerryCreate,
  mixins: [ValidationService],

  data() {
    const parentData = DailyFerryCreate.data.call(this);
    return {
      ...parentData,
      DFData: {
        ...parentData.DFData,
        teacher_id: null,
        skip_holiday: null,
      },
      holidayOptions: [
        {id: 1, text: "Teacher Holiday"},
        {id: 2, text: "Student Holiday"}
      ],
      teacherArr: [],
    };
  },

  methods: {
    ...DailyFerryCreate.methods,

    getPickupError(pickupId) {
      if (!this.validationErrors) return null;
      const idx = this.selectedPickups ? this.selectedPickups.indexOf(String(pickupId)) : -1;
      const indexedKey = `ferry_pickup_id.${idx}`;
      return (this.validationErrors[indexedKey] && this.validationErrors[indexedKey][0]) || (this.validationErrors.ferry_pickup_id && this.validationErrors.ferry_pickup_id[0]) || null;
    },

    getTeacher() {
      axios.get('/teacher/getallTeacher', {
        params: {
          campus_id: this.$store.state.user.campus_id
        }
      })
        .then(res => {
          this.teacherArr = res.data[0];
        }).catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },
    create() {
      this.submitted = true;
      if (this.DFData.from_date && this.DFData.to_date && new Date(this.DFData.to_date) < new Date(this.DFData.from_date)) {
        this.dateError = true;
      } else {
        this.dateError = false;
      }
      if ((this.pickupData != null && this.selectedPickups.length == 0) || this.selectedPickups.length == 0) {
        this.pointError = true;
      } else {
        this.pointError = false;
      }
      if (this.$v.$invalid || this.pointError || this.dateError) {
        return;
      }

      const request = structuredClone(this.DFData);
      request.loginId = this.$store.state.user.id;
      request.ferry_pickup_id = this.selectedPickups;
      request.campus_id = this.$store.state.user.campus_id;
      request.skip_holiday = this.DFData.skip_holiday;
      this.disabled = true;
      this.isLoading = true;

      axios.post('dailyFerry/create', request)
        .then(res => {
          if (res.data.success == true) {
            this.$notification.success("Daily Ferry Added Successfully", {
              timer: 3,
              position: "bottomCenter"
            });
            this.$router.push({ name: 'dailyFerryList' })
          } else {
            this.disabled = false;
            this.isLoading = false;
            this.$notification.error(res.data.message, {
              timer: 3,
              position: "bottomCenter"
            });
          }
          this.disabled = false;

        }).catch(error => {
          this.disabled = false;
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          if (error.response.status == 422) {
            // Print validation errors using ValidationService mixin
            this.printValidationError(error.response);
            const errors = (error.response.data && error.response.data.errors) || {};
            const keys = Object.keys(errors);
            const onlyPickupErrors = keys.length > 0 && keys.every(k => k.startsWith('ferry_pickup_id'));
            if (!onlyPickupErrors && error.response.data.message) {
              this.$notification.error(error.response.data.message, {
                timer: 3,
                position: "bottomCenter",
              });
            }
          }
          this.isLoading = false;
        });
    },
    skipTypeChange(typeId) {
      if (typeId == this.DFData.skip_holiday) {
        this.DFData.skip_holiday = null;
      }
    }
  },

  mounted() {
    this.getTeacher();
  }
};
